import { useEffect, useState } from "react";

// Collapsible panel state remembered per browser: once hidden it stays hidden until the user opens it again.
export default function usePersistedOpen(key, initial = true) {
  const k = `supplivo.panel.${key}`;
  const [open, setOpen] = useState(() => {
    try { const v = localStorage.getItem(k); return v === null ? initial : v === "1"; } catch { return initial; }
  });
  useEffect(() => { try { localStorage.setItem(k, open ? "1" : "0"); } catch { /* storage unavailable */ } }, [k, open]);
  return [open, setOpen];
}
